import * as React from 'react';
import { useActions } from '../viewActions';
import { Arrow } from 'rcd-cpp-ui/ui/icon/Arrow';
import { Breadcrumb } from '../../Breadcrumb/breadcrumb';
import { BackupModeButton } from '../BackupMode/backupMode';
import { useSelector } from '../../../utils/useSelector';

export const ViewDescription = () => {
  const refId = useSelector(s => s.view?.selected?.props?.refId);
  const collapseDescription = useSelector(s => {
    const userSettings = s.planning?.userSettings;
    return userSettings
      ? userSettings[refId]?.props?.collapseDescription
      : true;
  });
  const selected = useSelector(s => s.view?.selected);
  const selectedWorkspace = useSelector(s => s.planning?.selectedWorkspace);
  const isViewingAs = !!useSelector(s => s.view?.viewingAs?.props?.empCd);

  let selectedFolder = '';
  selectedWorkspace?.folders?.forEach(f => {
    f?.views?.forEach(v => {
      if (v?.props?.refId == refId) {
        selectedFolder = f?.props?.name;
      }
    });
  });

  const { setViewSettings } = useActions();

  return (
    <>
      <div>
        <Breadcrumb
          paths={[
            selectedWorkspace?.props?.name,
            selected?.category,
            selectedFolder,
            selected?.props.name
          ]}
        />
        {refId && (
          <div
            className="collapse-description"
            onClick={() =>
              setViewSettings({ collapseDescription: !collapseDescription })
            }
          >
            <Arrow
              type="solid"
              direction={collapseDescription ? 'up' : 'down'}
            />
            {collapseDescription ? 'Show Details' : 'Hide Details'}
          </div>
        )}
        {!isViewingAs && <BackupModeButton />}
      </div>
      {!collapseDescription && (
        <div>
          {selected?.props?.description ||
            selectedWorkspace?.props?.description ||
            ''}
        </div>
      )}
    </>
  );
};
